import tw, { classnames, translate, inset } from 'tailwindcss-classnames'
import { Carousel, CarouselNext, CarouselPrev, Review as ReviewItem } from '..'
import { Review } from 'src/packages/domain'


type Props = {
    reviews?: Review[]
}

const arrowStyle = classnames(translate("translate-y-full"))

const sliderSettings = {
    dots: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        }        
    ],
    nextArrow: <CarouselNext twClassName={`sm:-translate-x-full ${classnames(arrowStyle, inset("left-0", "sm:left-0", "xl:left-4", "top-auto", "bottom-0", "xl:bottom-0"))}`} />,
    prevArrow: <CarouselPrev twClassName={`sm:translate-x-full ${classnames(
        arrowStyle, 
        inset("right-0", "sm:right-0", "xl:right-4", "top-auto", "bottom-0", "xl:bottom-0")
    )}`} />    
}

const ReviewCarousel = ({reviews}: Props) => (
    <Carousel {...sliderSettings}>
        { reviews && reviews.map((review,i) =>
            <div className="rtl" key={i}>
                <ReviewItem  {...review} />
            </div>
        )}
    </Carousel>
)

export default ReviewCarousel